// import 'Src/basic/boot/index'
import 'Src/basic/new-boot/promotion-boot'
import Apps from 'Src/pagelets/promotion/index.vue'
import router from './router.js'
import store from './store.js'
import buiIconAddon from './bui-icon-addon.js'
import plugins from './plugins'
import PerfMonitor from '@ad/perf-monitor/lib/index.umd'
import { promotionTTIMonitor, BEFORE_ENTRY_RUN } from 'Src/util/perf-monitor/monitors'

PerfMonitor.init({
  tags: {
    ads_session_id: window.sessionId || '',
    slardar_session_id: window.Slardar?.shared?.config?.commonParams?.slardar_session_id || '',
    adv_id: GLOBAL_VAR.advertiser?.id || '',
    first_industry_id_v3: GLOBAL_VAR.advertiser?.first_industry_id_v3 || '',
    second_industry_id_v3: GLOBAL_VAR.advertiser?.second_industry_id_v3 || '',
    customer_type: GLOBAL_VAR.customerType || ''
  }
})
promotionTTIMonitor.mark(BEFORE_ENTRY_RUN)

Vue.use(BUI)
Vue.use(buiIconAddon)
Vue.use(plugins)

export default new Vue({
  router,
  store,
  el: '#app',
  render: creator => creator(Apps)
})
